(() => {
  if (window.__forgetechCategoryPeekReady) return;
  window.__forgetechCategoryPeekReady = true;

  const hydratePanel = (panel) => {
    const template = panel?.querySelector(':scope > template[data-category-peek-template]');
    if (!template) return;

    panel.appendChild(template.content.cloneNode(true));
    template.remove();
    panel.dataset.categoryPeekHydrated = 'true';
  };

  const hydrateIndex = (tabs, index) => {
    const panels = Array.from(tabs.querySelectorAll(':scope > [data-category-peek-panel]'));
    hydratePanel(panels[index]);
  };

  const tabIndex = (tabs, tab) =>
    Array.from(tabs.querySelectorAll(':scope > [data-category-peek-tab]')).indexOf(tab);

  const observeTabs = (scope = document) => {
    const tabsList = [];

    if (scope instanceof Element && scope.matches('x-tabs.category-peek')) tabsList.push(scope);
    scope.querySelectorAll?.('x-tabs.category-peek').forEach((tabs) => tabsList.push(tabs));

    tabsList.forEach((tabs) => {
      if (tabs.dataset.categoryPeekReady === 'true') return;
      tabs.dataset.categoryPeekReady = 'true';
      hydrateIndex(tabs, Number.parseInt(tabs.getAttribute('selected-index') || '0', 10));

      new MutationObserver(() => {
        hydrateIndex(tabs, Number.parseInt(tabs.getAttribute('selected-index') || '0', 10));
      }).observe(tabs, { attributes: true, attributeFilter: ['selected-index'] });
    });
  };

  document.addEventListener('click', (event) => {
    const tab = event.target.closest?.('[data-category-peek-tab]');
    const tabs = tab?.closest('x-tabs.category-peek');
    if (!tabs) return;
    hydrateIndex(tabs, tabIndex(tabs, tab));
  }, true);

  document.addEventListener('keydown', (event) => {
    if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    const tab = event.target.closest?.('[data-category-peek-tab]');
    const tabs = tab?.closest('x-tabs.category-peek');
    if (!tabs) return;

    const count = tabs.querySelectorAll(':scope > [data-category-peek-tab]').length;
    const current = tabIndex(tabs, tab);
    const next = event.key === 'ArrowLeft'
      ? (current - 1 + count) % count
      : (current + 1) % count;
    hydrateIndex(tabs, next);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observeTabs(), { once: true });
  } else {
    observeTabs();
  }

  document.addEventListener('shopify:section:load', (event) => observeTabs(event.target));
})();
